import SharedString from "../utils/SharedString";

class StorageManager {

    clearUserInfo(){
        this.clearJWTToken();
        this.clearUserMail();
        this.clearLoginStatus();
        this.clearBasketItem();
        this.clearActiveUser();
    }
    storeJWTToken(jwt){
        localStorage.setItem(SharedString.JWT_TOKEN_FIELD, jwt);
    }

    getJWTToken(){
        return localStorage.getItem(SharedString.JWT_TOKEN_FIELD);
    }

    clearJWTToken(){
        localStorage.removeItem(SharedString.JWT_TOKEN_FIELD);
    }

    storeLoginStatus(loginStatus){
        localStorage.setItem(SharedString.LOGIN_FIELD, loginStatus);
    }

    getLoginStatus(){
        return localStorage.getItem(SharedString.LOGIN_FIELD)
    }

    clearLoginStatus(){
        localStorage.removeItem(SharedString.LOGIN_FIELD);
    }

    storeUserMail(userMail){
        localStorage.setItem(SharedString.USERID_FIELD, userMail)
    }

    getUserMail(){
        return localStorage.getItem(SharedString.USERID_FIELD)
    }

    clearUserMail(){
        localStorage.removeItem(SharedString.USERID_FIELD)
    }

    storeBasketItem(basketProduct){
        localStorage.setItem(SharedString.BASKET_FIELD, JSON.stringify(basketProduct))
    }


    getBasketItem(){
        let retrived = localStorage.getItem(SharedString.BASKET_FIELD)

        if(retrived === null){
            return null
        } else {
            return JSON.parse(retrived)
        }
    }

    clearBasketItem(){
        localStorage.removeItem(SharedString.BASKET_FIELD)
    }

    storeActiveUser(userInitial){
        localStorage.setItem(SharedString.ACTIVE_USER, userInitial)
    }
    getActiveUser(){
        return localStorage.getItem(SharedString.ACTIVE_USER)
    }

    clearActiveUser(){
        localStorage.removeItem(SharedString.ACTIVE_USER)
    }
}

export default new StorageManager();